module.exports = __webpack_public_path__ + "static/img/product10-1.70f97b25.png";